var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{attrs:{"label":"Nome Completo","placeholder":"Qual seu nome?"},on:{"change":_vm.onChange},model:{value:(_vm.nome),callback:function ($$v) {_vm.nome=$$v},expression:"nome"}})}
var staticRenderFns = []

export { render, staticRenderFns }